//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GQL from './gql'
import gql from 'graphql-tag'
import SwoopForm from '@/components/SwoopForm'
import ActionButtons from '@/components/ActionButtons'
import { convertTicketFields } from './fieldConverter'
import API from '@/api/apiHelper'
export default {
  name: 'Wizard',
  components: {
    SwoopForm,
    ActionButtons
  },

  props: ['ticket_id', 'ticket_status'],

  data: function() {
    return {
      ticket: {
        active_workflow_step: null
      },
      ticketData: {},
      wizardFields: [],
      loading: true,
      form: null,
      fields: []
    }
  },

  apollo: {
    ticket: {
      query: GQL.ticketWizard,
      variables() {
        return {
          id: this.ticket_id
        }
      },
      skip() {
        return !this.ticket_id
      }
    }
  },

  watch: {
    ticket: function() {
      this.ticketData = JSON.parse(this.ticket.ticket_data)
      this.wizardFields = JSON.parse(this.ticket.wizard_fields)
      this.renderForm()
      this.loading = false
    }
  },

  computed: {
    page() {
      return this.form ? this.form.getPage() : 1
    },
    pageIndex() {
      return this.page - 1
    },
    title: function() {
      switch (this.ticket_status) {
        case 'CREATING':
          return 'Ticket creator'
        case 'CLOSING':
          return 'Ticket closer'
        default:
          return 'Ticket wizard'
      }
    },
    pages: function() {
      return this.wizardFields.map(page => {
        return { label: page.name, step: page.fields[0].name }
      })
    },
    lastSection: function() {
      return this.page === this.pages.length
    },
    cancelWizard: function() {
      switch (this.ticket_status) {
        case 'CREATING':
          return this.deleteTicket
        case 'CLOSING':
          return this.reopenTicket
        default:
          return function() {}
      }
    }
  },

  methods: {
    renderForm() {
      let fieldsIn = []
      this.wizardFields.forEach((step, stepIdx) => {
        step.fields[0].fields.forEach(field => {
          field._page = stepIdx + 1
          fieldsIn.push(field)
        })
      })
      this.fields = convertTicketFields(fieldsIn, this.ticketData)
      if (this.form) {
        this.form.load(this.ticketData)
        let pageIdx = this.pages.findIndex(
          p => p.step === this.ticket.active_workflow_step
        )
        this.form.setPage(pageIdx + 1)
      }
    },

    completeSection: async function() {
      if (this.form.focusError()) {
        return // Invalid field(s) found
      }

      let data = await API.mutate(
        `
        mutation($ticket_id: ID!) {
          completeWizardSection(id: $ticket_id) {
            active_workflow_step
            ticket_data
          }
        }
        `,
        {
          ticket_id: this.ticket_id
        }
      )
      if (this.lastSection) {
        window.location.reload()
      } else {
        this.ticketData = JSON.parse(data.ticket_data)
        this.ticket.active_workflow_step = data.active_workflow_step
        this.renderForm()
      }
    },

    stepBack() {
      if (this.pageIndex === 0) {
        this.cancelWizard()
      } else {
        this.reverseSection()
      }
    },

    async reverseSection() {
      let data = await API.mutate(
        `
          mutation($ticket_id: ID!) {
            reverseWizardSection(id: $ticket_id) {
              active_workflow_step
            }
          }
        `,
        {
          ticket_id: this.ticket_id
        },
        {
          spinner: false
        }
      )
      this.ticket.active_workflow_step = data.active_workflow_step
      this.form.setPage(this.page - 1)
    },

    updateTicketData: async function() {
      this.loading = true
      await this.$apollo
        .mutate({
          mutation: gql`
            mutation($ticket_id: ID!, $ticket_data: JSON!) {
              updateTicketData(id: $ticket_id, ticket_data: $ticket_data) {
                ticket_data
              }
            }
          `,
          variables: {
            ticket_id: this.ticket_id,
            ticket_data: JSON.stringify(this.ticketData)
          }
        })
        .then(() => {
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    deleteTicket: async function() {
      await this.$store.dispatch('confirm', {
        text: `Cancel ticket?`,
        detail: 'This ticket will be permanently removed.',
        okText: 'Yes',
        cancelText: 'No'
      })
      await this.$apollo
        .mutate({
          mutation: gql`
            mutation($ticket_id: ID!) {
              cancelTicket(id: $ticket_id)
            }
          `,
          variables: {
            ticket_id: this.ticket_id
          }
        })
        .then(() => {
          this.$router.push(`/support`)
        })
        .catch(() => {})
    },

    reopenTicket: async function() {
      // To be implemented
    }
  }
}
